var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card settings-area"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.settingNames),function(name){return _c('setting-card',{key:name,attrs:{"settings-obj":_vm.settingsObject,"name":name}})})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-heading"},[_vm._v("Settings (In development: settings don't yet do anything)")])])
}]

export { render, staticRenderFns }